import React, { useState, useEffect, useRef } from 'react'
import { Radio, Select, Col, Row, Input, Checkbox, Space, Tooltip } from "antd";
import axios from "axios";
import configData from "../../../config/config.json";
import constantData from "../../../constants/constantData.json";
import Cookies from "js-cookie";
import { notifyfailure } from "../../../utils/toast";
import { notifycatch } from "../../../utils/toast";
import loaderIcon from '../../../assets/images/icons/loader.gif';
import { notifysuccess } from "../../../utils/toast";
import { Link } from "react-router-dom";
import backButton from '../../../assets/images/back_button_arrow.svg';
import publishersIcon from '../../../assets/images/icons/publishers.svg';
import uploadIcon from '../../../assets/images/icons/upload-cloud.svg';
import FileIcon from '../../../assets/images/icons/offcanva_file_icon.svg';
import deleteIcon from '../../../assets/images/icons/trash.svg';
import DownloadOrangeIcon from '../../../assets/images/icons/download_csv_icon.svg';


const OnboardingStep1 = (props) => {

    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });

    useEffect(() => {

        if (props.callFrom === "register") {
            setName(props.signupData.p_name)
            setCompanyName(props.signupData.o_name)
            setEmail(props.signupData.email)
            setCompanyWebsite(props.signupData.c_website)
            if (
                props.signupData.im &&
                typeof props.signupData.im === "object" &&
                Object.keys(props.signupData.im).length !== 0
            ) {
                const imKey = Object.keys(props.signupData.im)[0];
                const imValue = props.signupData.im[imKey];
                setSelectedIm(imKey);
                setIm(imValue);
            }
        }
        else if (props.callFrom === "onboarding") {

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
                let token = Cookies.get("token_xapads_ssp");
                axios
                    .get((configData.SERVER_URL + "ops/getPubDetails?_id=" + (props.callFrom === "listing" ? props.id : "")), {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    })
                    .then((response) => {

                        // if (props.callFrom === "onboarding") {
                        //     if (response?.data?.data?.onboard_filled && (response?.data?.data?.status === "onboard" || response?.data?.data?.status === "rejected")) {
                        //         setIsDisabled(true)
                        //     }
                        // }

                        setCurrentStatus(response?.data?.data?.status)

                        setName(response?.data?.data?.p_name || "");
                        setPoc(response?.data?.data?.poc || "");
                        setCompanyName(response?.data?.data?.o_name || "");
                        setCompanyWebsite(response?.data?.data?.c_website || "");
                        setEmail(response?.data?.data?.email || "");
                        setSelectedIm(response?.data?.data?.im?.label || "");
                        setIm(response?.data?.data?.im?.value || "");
                        setCountry(response?.data?.data?.address?.country || "");
                        setCompanyLinkedin(response?.data?.data?.o_contact || "");

                        // setImportUrl(response?.data?.data?.media_link || "");

                        setDefineYourself(response?.data?.data?.defineYourself || [])
                        setIsMcm(response?.data?.data?.isMcm ?? null)
                        setGamEmail(response?.data?.data?.gamEmail || "")
                        setGamNetworkId(response?.data?.data?.gamNetworkCode || "")

                        setInventoryMonetize(response?.data?.data?.inventory_type_select || [])
                        setInventoryMonetizeOther(response?.data?.data?.inventory_type_select_other || "")
                        setInventoryMonetizeWebsiteUserSync(response?.data?.data?.inventory_type_select_website_usersync ?? null)
                        setInventoryMonetizeWebsiteBanner(response?.data?.data?.inventory_type_select_website_bannerPlacement ?? null)

                        setMediakit2(response?.data?.data?.mediaKit || [])
                        setImportUrl(response?.data?.data?.media_link || "")
                    })
                    .catch((error) => {
                        notifyfailure("Failed to fetch the publisher details.")
                    });
            }
        }

    }, [props])

    useEffect(() => {

        axios
            .get(configData.SERVER_URL + "user/countryList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setCountryOptions(response.data.data);
            })
            .catch((error) => { });

    }, [])

    const [buttonValue, setButtonValue] = useState(false);


    const [currentStatus, setCurrentStatus] = useState("");

    const [name, setName] = useState("");
    const [nameIsRequiredError, setNameIsRequiredError] = useState(false);

    const [poc, setPoc] = useState("");
    const [pocIsRequiredError, setPocIsRequiredError] = useState(false);

    const [companyName, setCompanyName] = useState("");
    const [companyNameIsRequiredError, setCompanyNameIsRequiredError] =
        useState(false);

    const [email, setEmail] = useState("");

    const [companyWebsite, setCompanyWebsite] = useState("");
    const [companyWebsiteIsRequiredError, setCompanyWebsiteIsRequiredError] =
        useState(false);
    const [companyWebsiteUrlError, setCompanyWebsiteUrlError] = useState(false);

    const [im, setIm] = useState("");
    const [imIsRequiredError, setImIsRequiredError] = useState(false);

    const [selectedIm, setSelectedIm] = useState("telegram");

    const [countryOptions, setCountryOptions] = useState([]);
    const [country, setCountry] = useState("");

    const [companyLinkedin, setCompanyLinkedin] = useState("");
    const [companyLinkedinUrlError, setCompanyLinkedinUrlError] = useState(false);

    const [defineYourself, setDefineYourself] = useState([]);
    const [defineYourselfIsRequiredError, setDefineYourselfIsRequiredError] = useState(false);

    const [isMcm, setIsMcm] = useState(null);
    const [isMcmIsRequiredError, setIsMcmIsRequiredError] = useState(false);
    const [gamEmail, setGamEmail] = useState("");
    const [gamEmailIsRequiredError, setGamEmailIsRequiredError] = useState(false);
    const [gamEmailUrlError, setGamEmailUrlError] = useState(false);
    const [gamNetworkId, setGamNetworkId] = useState("");
    const [gamNetworkIdIsRequiredError, setGamNetworkIdIsRequiredError] = useState(false);

    const [inventoryMonetize, setInventoryMonetize] = useState([]);
    const [inventoryMonetizeIsRequiredError, setInventoryMonetizeIsRequiredError] = useState(false);
    const [inventoryMonetizeOther, setInventoryMonetizeOther] = useState("");
    const [inventoryMonetizeOtherIsRequiredError, setInventoryMonetizeOtherIsRequiredError] = useState(false);
    const [inventoryMonetizeWebsiteUserSync, setInventoryMonetizeWebsiteUserSync] = useState(null);
    const [inventoryMonetizeWebsiteUserSyncIsRequiredError, setInventoryMonetizeWebsiteUserSyncIsRequiredError] = useState(false);
    const [inventoryMonetizeWebsiteBanner, setInventoryMonetizeWebsiteBanner] = useState(null);
    const [inventoryMonetizeWebsiteBannerIsRequiredError, setInventoryMonetizeWebsiteBannerIsRequiredError] = useState(false);

    const [mediakit, setMediakit] = useState([]);
    const [mediakit2, setMediakit2] = useState([]);
    const [importUrl, setImportUrl] = useState("");
    const [importUrlError, setImportUrlError] = useState(false);


    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const validateWebsiteUrl = (websiteUrl) => {
        return String(websiteUrl)
            .toLowerCase()
            .match(/.+[.].+/);
    };

    const validateLinkedinUrl = (linkedinUrl) => {
        return String(linkedinUrl)
            .toLowerCase()
            .match(/^(https?:\/\/)?([^/]+\.)?(linkedin\.[a-zA-Z]+\/.*)$/);
    };

    function onChangeName(event) {
        setNameIsRequiredError(false);
        setName(event.target.value);
    }

    function onBlurName(event) {
        if (event.target.value.trim().length === 0) {
            setNameIsRequiredError(true);
        }
        setName(event.target.value.trim());
    }

    function onChangePoc(event) {
        setPocIsRequiredError(false);
        setPoc(event.target.value);
    }

    function onBlurPoc(event) {
        if (event.target.value.trim().length === 0) {
            setPocIsRequiredError(true);
        }
        setPoc(event.target.value.trim());
    }

    function onChangeCompanyName(event) {
        setCompanyNameIsRequiredError(false);
        setCompanyName(event.target.value);
    }

    function onBlurCompanyName(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyNameIsRequiredError(true);
            setCompanyName("");
        }
        setCompanyName(event.target.value.trim());
    }

    function onChangeIm(event) {
        setImIsRequiredError(false);
        setIm(event.target.value);
    }

    function onBlurIm(event) {
        if (event.target.value.trim().length === 0) {
            setImIsRequiredError(true);
        }
        setIm(event.target.value.trim());
    }

    function onChangeSelectedIm(event) {
        setSelectedIm(event);
    }

    function onChangeCompanyWebsite(event) {
        setCompanyWebsite(event.target.value);

        if (event.target.value.length === 0) {
            setCompanyWebsiteUrlError(false);
            setCompanyWebsiteIsRequiredError(true);
        } else {
            setCompanyWebsiteIsRequiredError(false);

            if (validateWebsiteUrl(event.target.value) === null) {
                setCompanyWebsiteUrlError(true);
            } else {
                setCompanyWebsiteUrlError(false);
            }
        }
    }

    function onBlurCompanyWebsite(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyWebsiteUrlError(false);
            setCompanyWebsiteIsRequiredError(true);
        } else {
            if (validateWebsiteUrl(event.target.value.trim()) === null) {
                setCompanyWebsiteUrlError(true);
            } else {
                setCompanyWebsiteUrlError(false);
            }
        }
        setCompanyWebsite(event.target.value.trim());
    }


    function onChangeCompanyLinkedin(event) {
        setCompanyLinkedin(event.target.value);
        if (event.target.value.length === 0) {
            setCompanyLinkedinUrlError(false);
        } else {
            if (validateLinkedinUrl(event.target.value) === null) {
                setCompanyLinkedinUrlError(true);
            } else {
                setCompanyLinkedinUrlError(false);
            }
        }
    }

    function onBlurCompanyLinkedin(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyLinkedinUrlError(false);
        }
        else {
            if (validateLinkedinUrl(event.target.value.trim()) === null) {
                setCompanyLinkedinUrlError(true);
            } else {
                setCompanyLinkedinUrlError(false);
            }
        }
        setCompanyLinkedin(event.target.value.trim());
    }

    function onChangeDefineYourself(event) {
        if (event.length === 0) {
            setDefineYourselfIsRequiredError(true)
        }
        else {
            setDefineYourselfIsRequiredError(false)
        }
        setDefineYourself(event)
    }

    function onChangeIsMcm(event) {
        setIsMcmIsRequiredError(false)
        setIsMcm(event.target.value);
    }

    function onChangeGamEmail(event) {
        setGamEmailIsRequiredError(false);
        setGamEmail(event.target.value);

        if (validateEmail(event.target.value) === null) {
            setGamEmailUrlError(true);
        } else {
            setGamEmailUrlError(false);
        }
    }

    function onBlurGamEmail(event) {
        if (event.target.value.trim().length === 0) {
            setGamEmailUrlError(false);
            setGamEmailIsRequiredError(true);
        }
        else {
            if (validateEmail(event.target.value.trim()) === null) {
                setGamEmailUrlError(true);
            } else {
                setGamEmailUrlError(false);
            }
        }
        setGamEmail(event.target.value.trim());
    }


    function onChangeGamNetworkId(event) {
        setGamNetworkIdIsRequiredError(false);
        setGamNetworkId(event.target.value);
    }

    function onBlurGamNetworkId(event) {
        if (event.target.value.trim().length === 0) {
            setGamNetworkIdIsRequiredError(true);
        }
        setGamNetworkId(event.target.value.trim());
    }

    function onChangeInventoryMonetize(event) {
        if (event.length === 0) {
            setInventoryMonetizeIsRequiredError(true)
        }
        else {
            setInventoryMonetizeIsRequiredError(false)
        }
        if (!event.includes("Others")) {
            setInventoryMonetizeOtherIsRequiredError(false);
        }
        setInventoryMonetize(event)
    }

    function onChangeInventoryMonetizeWebsiteUserSync(event) {
        setInventoryMonetizeWebsiteUserSyncIsRequiredError(false)
        setInventoryMonetizeWebsiteUserSync(event.target.value);
    }

    function onChangeInventoryMonetizeWebsiteBanner(event) {
        setInventoryMonetizeWebsiteBannerIsRequiredError(false)
        setInventoryMonetizeWebsiteBanner(event.target.value);
    }

    function onChangeMediakit(e) {
        let count = 0;
        if (e.target.files.length > 0) {
            let tempMediaKit = [...mediakit];
            for (let file of e.target.files) {
                if (file.size / (1024 * 1024) < 100) {
                    tempMediaKit.push({ data: file, preview: URL.createObjectURL(file), filename: file.name, size: file.size });
                } else { count++; }
            }
            setMediakit(tempMediaKit);
            const fileInput = document.getElementById("file000_step1");
            if (fileInput) fileInput.value = "";
            if (count !== 0) notifyfailure(`${count} files are rejected as they are failing validation (File should be Less than 100mb)`);
        }
    }

    const fetchAndDownloadFilesMediaKit = async (ob) => {
        try {
            const response = await fetch(ob.url);
            if (!response.ok) throw new Error(`Failed to fetch ${ob?.url}: ${response.statusText}`);
            const blob = await response.blob();
            const filename = `${ob.fileName}${ob.fileName.includes("." + ob?.ext) ? "" : `${"." + ob.ext}`}`;
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            notifysuccess("File downloaded successfully");
        } catch (error) {
            notifyfailure("Error while fetching the media kit.");
        }
    };

    function onChangeImportUrl(event) {
        setImportUrl(event.target.value);
        if (event.target.value.length === 0) setImportUrlError(false);
        else { if (validateWebsiteUrl(event.target.value) === null) setImportUrlError(true); else setImportUrlError(false); }
    }

    function onBlurImportUrl(event) {
        if (event.target.value.trim().length === 0) setImportUrlError(false);
        else { if (validateWebsiteUrl(event.target.value.trim()) === null) setImportUrlError(true); else setImportUrlError(false); }
        setImportUrl(event.target.value.trim());
    }


    const scrollToItem = (ref, offset = 80) => {
        if (ref && ref.current) {
            ref.current.style.scrollMarginTop = `${offset}px`;
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setTimeout(() => {
                ref.current.style.scrollMarginTop = '';
            }, 0);
        }
    };

    const basicDetailsRef = useRef(null)
    const defineYourselfRef = useRef(null)
    const mcmRef = useRef(null)
    const inventoryMonetizeRef = useRef(null)

    const errorDetect = () => {

        if (name.trim() === "" || nameIsRequiredError || poc.trim() === "" || pocIsRequiredError || companyName.trim() === "" || companyNameIsRequiredError || companyWebsite.trim() === "" || companyWebsiteIsRequiredError || companyWebsiteUrlError || im.trim() === "" || imIsRequiredError || companyLinkedinUrlError) {
            scrollToItem(basicDetailsRef);
            return
        }

        if (defineYourself.length === 0 || defineYourselfIsRequiredError) {
            scrollToItem(defineYourselfRef);
            return
        }

        if (isMcm === null || isMcmIsRequiredError ||
            (isMcm ? gamEmail.trim === "" : false) ||
            (isMcm ? gamNetworkId.trim === "" : false) ||
            (isMcm ? gamEmailIsRequiredError : false) ||
            (isMcm ? gamEmailUrlError : false) ||
            (isMcm ? gamNetworkIdIsRequiredError : false)
        ) {
            scrollToItem(mcmRef);
            return
        }

        if (inventoryMonetize.length === 0 || inventoryMonetizeIsRequiredError ||
            (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteUserSync === null : false) ||
            (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteBanner === null : false) ||
            (inventoryMonetize.includes("Others") ? inventoryMonetizeOther.trim() === "" : false)
        ) {
            scrollToItem(inventoryMonetizeRef);
            return
        }
    }


    // const handleCancel = () => {
    //     setName("");
    //     setNameIsRequiredError(false);
    //     setPoc("");
    //     setPocIsRequiredError(false);
    //     setCompanyName("");
    //     setCompanyNameIsRequiredError(false);
    //     setCompanyWebsite("");
    //     setCompanyWebsiteIsRequiredError(false);
    //     setCompanyWebsiteUrlError(false);
    //     setIm("");
    //     setImIsRequiredError(false);
    //     setSelectedIm("telegram");
    //     setCountry("");
    //     setCompanyLinkedin("");
    //     setCompanyLinkedinUrlError(false);
    //     setDefineYourself([]);
    //     setDefineYourselfIsRequiredError(false);
    //     setIsMcm(null);
    //     setIsMcmIsRequiredError(false);
    //     setGamEmail("");
    //     setGamEmailIsRequiredError(false);
    //     setGamEmailUrlError(false);
    //     setGamNetworkId("");
    //     setGamNetworkIdIsRequiredError(false);
    //     setInventoryMonetize([]);
    //     setInventoryMonetizeIsRequiredError(false);
    //     setInventoryMonetizeOther("");
    //     setInventoryMonetizeWebsiteUserSync(null);
    //     setInventoryMonetizeWebsiteUserSyncIsRequiredError(false);
    //     setInventoryMonetizeWebsiteBanner(null);
    //     setInventoryMonetizeWebsiteBannerIsRequiredError(false);

    //     if (props.callFrom === "register") {
    //         setEmail("");
    //     }
    // }


    const handleSubmit = async (e) => {
        e.preventDefault();
        errorDetect()

        if (
            name !== "" &&
            poc !== "" &&
            companyName !== "" &&
            companyWebsite !== "" &&
            im !== "" &&
            // country !== "" &&
            defineYourself.length !== 0 &&
            isMcm !== null &&
            (isMcm ? gamEmail !== "" : true) &&
            (isMcm ? gamNetworkId !== "" : true) &&
            inventoryMonetize.length !== 0 &&
            (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteUserSync !== null : true) &&
            (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteBanner !== null : true) &&
            (inventoryMonetize.includes("Others") ? inventoryMonetizeOther.trim() !== "" : true)
        ) {

            if (
                nameIsRequiredError === false &&
                pocIsRequiredError === false &&
                companyNameIsRequiredError === false &&
                companyWebsiteUrlError === false &&
                companyWebsiteIsRequiredError === false &&
                imIsRequiredError === false &&
                companyLinkedinUrlError === false &&
                defineYourselfIsRequiredError === false &&
                (isMcm ? gamEmailIsRequiredError === false : true) &&
                (isMcm ? gamEmailUrlError === false : true) &&
                (isMcm ? gamNetworkIdIsRequiredError === false : true) &&
                inventoryMonetizeIsRequiredError === false &&
                (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteUserSyncIsRequiredError === false : true) &&
                (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteBannerIsRequiredError === false : true) &&
                (inventoryMonetize.includes("Others") ? inventoryMonetizeOtherIsRequiredError === false : true)
            ) {

                let formData = new FormData();

                formData.append("p_name", name);
                formData.append("poc", poc);
                formData.append("o_name", companyName);
                formData.append("c_website", companyWebsite);
                formData.append("email", email);
                formData.append("im", JSON.stringify({ "label": selectedIm, "value": im }));
                formData.append("country", country);
                formData.append("o_contact", companyLinkedin);

                formData.append("defineYourself", JSON.stringify(defineYourself));

                formData.append("isMcm", isMcm);
                formData.append("gamEmail", gamEmail);
                formData.append("gamNetworkCode", gamNetworkId);

                formData.append("inventory_type_select", JSON.stringify(inventoryMonetize));
                formData.append("inventory_type_select_other", inventoryMonetizeOther);
                formData.append("inventory_type_select_website_usersync", inventoryMonetizeWebsiteUserSync);
                formData.append("inventory_type_select_website_bannerPlacement", inventoryMonetizeWebsiteBanner);

                formData.append("media_link", importUrl);
                mediakit.forEach((file) => { formData.append('mediaKit_new', file.data); });
                formData.append("mediaKit", JSON.stringify(mediakit2));

                formData.append("step", 1);

                if (props.callFrom === "register") {

                    setButtonValue(true);

                    const pubID = props.signupData?._id ?? props.id ?? "";
                    axios
                        .put(`${configData.SERVER_URL}ops/editPub?pubId=${pubID}`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            }
                        }
                        )
                        .then((response) => {

                            notifysuccess(response.data.message);

                            if (props.onNext) {
                                setTimeout(() => {
                                    props.onNext();
                                }, 100)
                            }
                            else {
                                setTimeout(() => {
                                    window.location.reload()
                                }, 1500)
                            }
                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }
                            setButtonValue(false);
                        });

                }
                else if (props.callFrom === "onboarding") {

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {

                        setButtonValue(true);
                        let token = Cookies.get("token_xapads_ssp");

                        axios
                            .put(`${configData.SERVER_URL}ops/editPub`, formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    "x-access-token": token,
                                }
                            }
                            )
                            .then((response) => {

                                notifysuccess(response.data.message);
                                if (props.onNext) {
                                    setTimeout(() => {
                                        props.onNext();
                                    }, 100)
                                } else {
                                    setTimeout(() => {
                                        window.location.reload()
                                    }, 1500)
                                }
                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                    }
                                } else {
                                    notifycatch();
                                }
                                setButtonValue(false);
                            });

                    }
                }
            }
        } else {
            if (name === "") {
                setNameIsRequiredError(true);
            }
            if (poc === "") {
                setPocIsRequiredError(true);
            }
            if (companyName === "") {
                setCompanyNameIsRequiredError(true);
            }
            if (companyWebsite === "") {
                setCompanyWebsiteIsRequiredError(true);
            }
            if (im === "") {
                setImIsRequiredError(true);
            }
            if (defineYourself.length === 0) {
                setDefineYourselfIsRequiredError(true);
            }
            if (isMcm === null) {
                setIsMcmIsRequiredError(true);
            }
            if (isMcm && gamEmail === "") {
                setGamEmailIsRequiredError(true);
            }
            if (isMcm && gamNetworkId === "") {
                setGamNetworkIdIsRequiredError(true);
            }
            if (inventoryMonetize.length === 0) {
                setInventoryMonetizeIsRequiredError(true);
            }
            if (inventoryMonetize.includes("Website") && inventoryMonetizeWebsiteUserSync === null) {
                setInventoryMonetizeWebsiteUserSyncIsRequiredError(true);
            }
            if (inventoryMonetize.includes("Website") && inventoryMonetizeWebsiteBanner === null) {
                setInventoryMonetizeWebsiteBannerIsRequiredError(true);
            }
            if (inventoryMonetize.includes("Others") && inventoryMonetizeOther.trim() === "") {
                setInventoryMonetizeOtherIsRequiredError(true);
            }
        }
    };


    return (
        <div className={props.callFrom === "register" ? "container_box--wrapper" : "container_box--wrapper pt_header"} style={{ paddingTop: props.callFrom === "register" ? '3rem' : '' }} >
            <div className="journey_header_div">

                <h2>Your Helix journey starts here </h2>

                <h5>Create your account and access your onboarding workspace.</h5>
                <hr className='new_bottom_line' />
            </div>


            <div className="container_box--content pt_20 form_scrollable_div_d2">
                {/* {currentStatus === "onboard" && isDisabled && props.callFrom === "onboarding" &&
                    <div className="container_box--width w-100">
                        <Row>
                            <Col span={24}>
                                <div className='profile_review_alert_div'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                        <path d="M18 5.625C15.33 5.625 12.7199 6.41676 10.4998 7.90016C8.27975 9.38356 6.54942 11.492 5.52763 13.9588C4.50585 16.4256 4.2385 19.14 4.7594 21.7587C5.28031 24.3775 6.56606 26.7829 8.45406 28.6709C10.3421 30.559 12.7475 31.8447 15.3663 32.3656C17.985 32.8865 20.6994 32.6192 23.1662 31.5974C25.633 30.5756 27.7414 28.8453 29.2248 26.6252C30.7082 24.4051 31.5 21.795 31.5 19.125C31.4959 15.5458 30.0723 12.1144 27.5414 9.58358C25.0106 7.05273 21.5792 5.62909 18 5.625ZM18 30.375C15.775 30.375 13.5999 29.7152 11.7498 28.479C9.89979 27.2429 8.45785 25.4859 7.60636 23.4302C6.75488 21.3745 6.53209 19.1125 6.96617 16.9302C7.40026 14.7479 8.47171 12.7434 10.0451 11.17C11.6184 9.59671 13.623 8.52525 15.8052 8.09117C17.9875 7.65708 20.2495 7.87987 22.3052 8.73136C24.3609 9.58284 26.1179 11.0248 27.354 12.8748C28.5902 14.7249 29.25 16.9 29.25 19.125C29.2467 22.1077 28.0603 24.9672 25.9513 27.0763C23.8422 29.1853 20.9827 30.3717 18 30.375ZM24.4209 12.7041C24.5255 12.8085 24.6085 12.9326 24.6651 13.0692C24.7218 13.2058 24.7509 13.3522 24.7509 13.5C24.7509 13.6478 24.7218 13.7942 24.6651 13.9308C24.6085 14.0674 24.5255 14.1915 24.4209 14.2959L18.7959 19.9209C18.6914 20.0255 18.5673 20.1084 18.4308 20.1649C18.2942 20.2215 18.1478 20.2506 18 20.2506C17.8522 20.2506 17.7058 20.2215 17.5692 20.1649C17.4327 20.1084 17.3086 20.0255 17.2041 19.9209C17.0995 19.8164 17.0166 19.6923 16.9601 19.5558C16.9035 19.4192 16.8744 19.2728 16.8744 19.125C16.8744 18.9772 16.9035 18.8308 16.9601 18.6942C17.0166 18.5577 17.0995 18.4336 17.2041 18.3291L22.8291 12.7041C22.9335 12.5995 23.0576 12.5165 23.1942 12.4599C23.3308 12.4033 23.4772 12.3741 23.625 12.3741C23.7728 12.3741 23.9192 12.4033 24.0558 12.4599C24.1924 12.5165 24.3165 12.5995 24.4209 12.7041ZM13.5 2.25C13.5 1.95163 13.6185 1.66548 13.8295 1.4545C14.0405 1.24353 14.3266 1.125 14.625 1.125H21.375C21.6734 1.125 21.9595 1.24353 22.1705 1.4545C22.3815 1.66548 22.5 1.95163 22.5 2.25C22.5 2.54837 22.3815 2.83452 22.1705 3.0455C21.9595 3.25647 21.6734 3.375 21.375 3.375H14.625C14.3266 3.375 14.0405 3.25647 13.8295 3.0455C13.6185 2.83452 13.5 2.54837 13.5 2.25Z" fill="#FA8E02" />
                                    </svg>
                                    <div>
                                        <h3>Profile under review!</h3>
                                        <p>Sit back and Relax your profile is currently under review by our team. We will notify you via email upon successful completion.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                }
                {currentStatus === "rejected" && isDisabled && props.callFrom === "onboarding" &&
                    <div className="container_box--width w-100">
                        <Row>
                            <Col span={24}>
                                <div className='profile_review_alert_div --rejected'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                        <path d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z" stroke="#D92D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M22.5 13.5L13.5 22.5" stroke="#D92D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M13.5 13.5L22.5 22.5" stroke="#D92D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    <div>
                                        <h3>Your account is rejected</h3>
                                        <p>Thank you for your interest. We regret to inform you that your account registration has been rejected after a review of your submitted information. Unfortunately, it does not meet the required criteria at this time.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                } */}
                <div className="container_box--width">
                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Basic details</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" ref={basicDetailsRef}>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Publisher Name *</label>
                                            <Input
                                                className={
                                                    nameIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={name}
                                                onBlur={onBlurName}
                                                onChange={onChangeName}
                                                autocomplete="off"

                                            />
                                            <span className='error_content'>
                                                {nameIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Full name of primary POC *</label>
                                            <Input
                                                className={
                                                    pocIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={poc}
                                                onBlur={onBlurPoc}
                                                onChange={onChangePoc}
                                                autocomplete="off"

                                            />
                                            <span className='error_content'>
                                                {pocIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Organisation Name *</label>
                                            <Input
                                                className={
                                                    companyNameIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={companyName}
                                                onBlur={onBlurCompanyName}
                                                onChange={onChangeCompanyName}
                                                autocomplete="off"

                                            />
                                            <span className='error_content'>
                                                {companyNameIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>

                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Company website *</label>
                                            <Input
                                                className={
                                                    (companyWebsiteIsRequiredError || companyWebsiteUrlError)
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={companyWebsite}
                                                onBlur={onBlurCompanyWebsite}
                                                onChange={onChangeCompanyWebsite}
                                                autocomplete="off"

                                            />
                                            <span className='error_content'>
                                                {companyWebsiteIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                                {companyWebsiteUrlError && (
                                                    <> Invalid Website Url</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Email Address *</label>
                                            <Input
                                                className="form_control basic"
                                                value={email}
                                                disabled
                                            />
                                            <span className="error_content"> </span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">IM * </label>
                                            <Space.Compact className='form_compact'>
                                                <Select
                                                    className='form_select'
                                                    value={selectedIm}
                                                    onChange={onChangeSelectedIm}
                                                    options={constantData.IM_OPTIONS}

                                                />
                                                <Input
                                                    className={imIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                    }
                                                    value={im}
                                                    onChange={onChangeIm}
                                                    onBlur={onBlurIm}
                                                    autocomplete="off"

                                                />
                                            </Space.Compact>
                                            <span className="error_content">
                                                {imIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>


                                    <Col span={12}>
                                        <div className="form_content_block--group mb-0">
                                            <label className="form_label">Headquarter Country</label>
                                            <Select
                                                showSearch
                                                placeholder='Select'
                                                optionFilterProp="label"
                                                className="form_select basic showing_placeholder_text"
                                                value={country || undefined}
                                                onChange={(event) => {
                                                    // setCountryIsRequiredError(false)
                                                    setCountry(event);
                                                }}
                                                options={countryOptions}

                                            />
                                            {/* <span className="error_content">
                                                {countryIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span> */}
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group mb-0">
                                            <label className="form_label">LinkedIn </label>
                                            <Input
                                                className={companyLinkedinUrlError
                                                    ? "form_control basic error"
                                                    : "form_control basic"
                                                }
                                                placeholder='https://'
                                                value={companyLinkedin}
                                                onBlur={onBlurCompanyLinkedin}
                                                onChange={onChangeCompanyLinkedin}
                                                autocomplete="off"

                                            />
                                            <span className="error_content">
                                                {companyLinkedinUrlError && (
                                                    <> Invalid LinkedIn Url</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>



                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Define Yourself *</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" ref={defineYourselfRef}>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group m-0">
                                            <div className=''>
                                                <Checkbox.Group className="form_checkbox equal_space"
                                                    value={defineYourself} onChange={onChangeDefineYourself}

                                                >
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width"
                                                        value="Direct Publisher">
                                                        Direct Publisher
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Aggregator / Reseller">
                                                        Aggregator / Reseller
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Network with owned & operated apps/sites">
                                                        Network with owned & operated apps/sites
                                                    </Checkbox>
                                                </Checkbox.Group>
                                                <span className="error_content">
                                                    {defineYourselfIsRequiredError && (
                                                        <> This field is required</>
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Do you accept MCM (Multiple Customer Management) invitation? *</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" ref={mcmRef}>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className={isMcm ? "form_content_block--group" : "form_content_block--group mb-0"}>
                                            <div className=''>
                                                <Radio.Group className="form_radio equal_space"
                                                    onChange={onChangeIsMcm} value={isMcm}

                                                >
                                                    <Radio className='radio_btn w-auto' value={true} onChange={onChangeIsMcm}>Yes</Radio>
                                                    <Radio className='radio_btn w-auto' value={false} onChange={onChangeIsMcm}>No</Radio>
                                                </Radio.Group>
                                                <span className="error_content">
                                                    {isMcmIsRequiredError && (
                                                        <> This field is required</>
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                    {isMcm && <>
                                        <Col span={12}>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label">Google Ad Manager Email ID *</label>
                                                <Input
                                                    className={(gamEmailIsRequiredError || gamEmailUrlError) ? 'form_control basic error' : 'form_control basic'}
                                                    autoComplete="off"
                                                    placeholder="example@gmail.com"
                                                    value={gamEmail}
                                                    onBlur={onBlurGamEmail}
                                                    onChange={onChangeGamEmail}

                                                />
                                                {gamEmailIsRequiredError && (
                                                    <span className="error_content">This field is required</span>
                                                )}
                                                {gamEmailUrlError && (
                                                    <span className="error_content">Invalid Email Address</span>
                                                )}
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label">GAM Network Code *</label>
                                                <Input
                                                    className={
                                                        gamNetworkIdIsRequiredError
                                                            ? "form_control basic error"
                                                            : "form_control basic"
                                                    }
                                                    value={gamNetworkId}
                                                    onBlur={onBlurGamNetworkId}
                                                    onChange={onChangeGamNetworkId}
                                                    autocomplete="off"

                                                />
                                                {gamNetworkIdIsRequiredError && (
                                                    <span className="error_content">This field is required</span>
                                                )}
                                            </div>
                                        </Col>
                                    </>}

                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>What kind of inventory do you want to monetize with us? *</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" ref={inventoryMonetizeRef}>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <div className=''>
                                                <Checkbox.Group className="form_checkbox equal_space"
                                                    value={inventoryMonetize}
                                                    onChange={onChangeInventoryMonetize}

                                                >
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width"
                                                        value="CTV / FAST Apps">
                                                        CTV / FAST Apps
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Mobile App (Android / iOS)">
                                                        Mobile App (Android / iOS)
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Website">
                                                        Website
                                                    </Checkbox>
                                                    <Checkbox className={inventoryMonetize.includes("Others") ? "checkbox_btn w-100 checkbox_with_input_design" : "checkbox_btn withoutchecked w-100 checkbox_with_input_design"} value="Others">
                                                        Others

                                                        <Input className='form_control basic' placeholder='Enter here' autoComplete="off"
                                                            disabled={(!inventoryMonetize.includes("Others"))}
                                                            value={inventoryMonetize.includes("Others") ? inventoryMonetizeOther : ""}
                                                            onChange={(e) => {
                                                                setInventoryMonetizeOther(e.target.value);
                                                                if (e.target.value.trim().length > 0) {
                                                                    setInventoryMonetizeOtherIsRequiredError(false);
                                                                }
                                                            }}
                                                        />


                                                    </Checkbox>
                                                    {inventoryMonetize.includes("Others") && inventoryMonetizeOtherIsRequiredError && (
                                                        <span className="error_content">Please provide value for others</span>
                                                    )}
                                                </Checkbox.Group>
                                                {inventoryMonetizeIsRequiredError && (
                                                    <span className="error_content">This field is required</span>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                    {inventoryMonetize.includes("Website") &&
                                        <>
                                            <Col span={24}>
                                                <hr className='divider_line' />
                                            </Col>
                                            <Col span={24}>
                                                <div className="form_content_block--group">
                                                    <div className=''>
                                                        <label className="form_label">Do you support User Syncing on websites?</label>
                                                        <Radio.Group className="form_radio equal_space"
                                                            value={inventoryMonetizeWebsiteUserSync}
                                                            onChange={onChangeInventoryMonetizeWebsiteUserSync}

                                                        >
                                                            <Radio className='radio_btn w-auto' value={true}>Yes</Radio>
                                                            <Radio className='radio_btn w-auto' value={false}>No</Radio>
                                                        </Radio.Group>
                                                        {inventoryMonetizeWebsiteUserSyncIsRequiredError && (
                                                            <span className="error_content">This field is required</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={24}>
                                                <div className="form_content_block--group mb-0">
                                                    <div className=''>
                                                        <label className="form_label">Do you allow Outstream video (IBV) over banner placements? (Website)</label>
                                                        <Radio.Group className="form_radio equal_space"
                                                            value={inventoryMonetizeWebsiteBanner}
                                                            onChange={onChangeInventoryMonetizeWebsiteBanner}

                                                        >
                                                            <Radio className='radio_btn w-auto' value={true}>Yes</Radio>
                                                            <Radio className='radio_btn w-auto' value={false}>No</Radio>
                                                        </Radio.Group>
                                                        {inventoryMonetizeWebsiteBannerIsRequiredError && (
                                                            <span className="error_content">This field is required</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </Col>
                                        </>
                                    }

                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Media Kit</label>
                            </div>
                        </Col>
                        <Col span={16}>
                            <div className="container_box--form-container"
                                style={{ paddingBottom: ((mediakit?.length ?? 0) + (mediakit2?.length ?? 0)) === 0 || ((mediakit?.length ?? 0) + (mediakit2?.length ?? 0)) === 1 ? "0px" : undefined }}>
                                {(mediakit?.length + mediakit2?.length) === 0 &&
                                    <Row gutter={16}>
                                        <Col span={11} className='file_uploaded_view_cls'>
                                            <div className="form_content_block--group mb-0">
                                                <label htmlFor='file000_step1' className='ant_upload_drag --updated_design_cls'>
                                                    <div className='d-flex align-items-center justify-content-start' style={{ gap: '1.2rem' }}>
                                                        <p className="upload_drag_icon mx-0"><img src={uploadIcon} alt='USP' /></p>
                                                        <div className='text-start'>
                                                            <p className="ant_upload_text mt-0"><b className="primary">Click to upload</b></p>
                                                            <p className="text-start ant_upload_hint">(max. 100 MB)</p>
                                                        </div>
                                                    </div>
                                                </label>
                                                <input className='form_upload d-none' type="file" name="file000_step1" id="file000_step1" multiple onChange={onChangeMediakit} />
                                            </div>
                                        </Col>
                                        <Col span={1} className="or-col">
                                            <div className="or-divider"><span>or</span></div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="form_content_block--group">
                                                <label className="form_label">Import from URL</label>
                                                <Input className={importUrlError ? "form_control basic error" : "form_control basic"}
                                                    placeholder='Paste your media kit URL' value={importUrl} onChange={onChangeImportUrl} onBlur={onBlurImportUrl} />
                                                <span className="error_content">{importUrlError && <>Invalid Url</>}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                }
                                {(mediakit?.length + mediakit2?.length) !== 0 &&
                                    <Row gutter={16}>
                                        <Col span={11} className='file_uploaded_view_cls'>
                                            <div className='new_file_upload_design_cls' style={{ paddingBottom: "0px" }}>
                                                <div className='d-flex align-items-start justify-content-between'>
                                                    <div style={{ width: "80%" }}>
                                                        {mediakit.map((media, index) => (
                                                            <div key={index} className="ant_upload_list--content border-0 padding-0">
                                                                <div className='d-flex align-items-start justify-content-between w-100'>
                                                                    <div className='d-flex align-items-center' style={{ width: "160px" }}>
                                                                        <img src={FileIcon} alt="USP" />
                                                                        <div className="ant_upload_list--info">
                                                                            <span className="ant_upload_list--info-name new_design_name ellipsis-2_text">
                                                                                <Tooltip title={media.filename}>{media.filename}</Tooltip>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className='d-flex'>
                                                                        <button type="button" className="ant_upload_list--delete"
                                                                            onClick={() => { let temp = [...mediakit]; temp.splice(index, 1); setMediakit(temp); }}>
                                                                            <Tooltip title="Delete"><img src={deleteIcon} alt="USP" /></Tooltip>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                        {mediakit2?.map((media, index) => (
                                                            <div key={index} className="ant_upload_list--content border-0 padding-0">
                                                                <div className='d-flex align-items-start justify-content-between w-100'>
                                                                    <div className='d-flex align-items-center' style={{ width: "160px" }}>
                                                                        <img src={FileIcon} alt="USP" />
                                                                        <div className="ant_upload_list--info">
                                                                            <span className="ant_upload_list--info-name new_design_name ellipsis-2_text">
                                                                                <Tooltip title={media.fileName}>{media.fileName}</Tooltip>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className='d-flex'>
                                                                        {media.hasOwnProperty('url') &&
                                                                            <button type="button" className="ant_upload_list--delete" onClick={() => fetchAndDownloadFilesMediaKit(media)}>
                                                                                <Tooltip title="Download"><img src={DownloadOrangeIcon} alt="USP" /></Tooltip>
                                                                            </button>
                                                                        }
                                                                        <button type="button" className="ant_upload_list--delete"
                                                                            onClick={() => { let temp = [...mediakit2]; temp.splice(index, 1); setMediakit2(temp); }}>
                                                                            <Tooltip title="Delete"><img src={deleteIcon} alt="USP" /></Tooltip>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <Tooltip title="Upload More">
                                                        <button type="button" className="upload_btn">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                <path d="M10.3637 10.3645L7.99924 8L5.63477 10.3645" stroke="#7434DB" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M8 8V13.3201" stroke="#7434DB" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M12.9591 11.7773C13.5356 11.4629 13.9911 10.9656 14.2536 10.3637C14.516 9.76176 14.5706 9.08958 14.4086 8.45321C14.2467 7.81685 13.8774 7.25255 13.3591 6.84937C12.8408 6.44618 12.203 6.22709 11.5463 6.22665H10.8015C10.6226 5.5346 10.2891 4.89211 9.82612 4.34748C9.36315 3.80286 8.78274 3.37028 8.12852 3.08226C7.4743 2.79425 6.7633 2.65828 6.04897 2.6846C5.33465 2.71092 4.63558 2.89884 4.00433 3.23422C3.37308 3.5696 2.82607 4.04371 2.40444 4.62093C1.9828 5.19814 1.6975 5.86343 1.56999 6.56678C1.44248 7.27013 1.47607 7.99323 1.66825 8.68172C1.86043 9.37022 2.20619 10.0062 2.67953 10.5418" stroke="#7434DB" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path d="M10.3637 10.3645L7.99924 8L5.63477 10.3645" stroke="#7434DB" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                            <input className='upload_btn' type="file" name="file000_step1" id="file000_step1" multiple onChange={onChangeMediakit} />
                                                        </button>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col span={1} className={((mediakit?.length ?? 0) + (mediakit2?.length ?? 0)) === 1 ? "or-col" : "or-col2"}>
                                            <div className="or-divider"><span>or</span></div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="form_content_block--group">
                                                <label className="form_label">Import from URL</label>
                                                <Input className={importUrlError ? "form_control basic error" : "form_control basic"}
                                                    placeholder='Paste your media kit URL' value={importUrl} onChange={onChangeImportUrl} onBlur={onBlurImportUrl} />
                                                <span className="error_content">{importUrlError && <>Invalid Url</>}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                }
                            </div>
                        </Col>
                    </Row>
                </div>

                <>
                    <div style={{ marginBottom: "8rem" }}></div>


                    <>
                        {/* <div className="hr_custom mb_20"></div> */}

                        <div className="btn_group justify-content-end gap_8 pb_50 edit_view_fixedbtn_d2">
                            {/* <button className='w_120_d2 btn btn_secondary w_fit_content'
                                style={{ color: "black" }}
                                onClick={handleCancel}
                                type="button"
                            >
                                <span>Cancel</span>
                            </button> */}

                            {buttonValue ? (
                                <button className='btn_primary btn loader w_120_d2 btn btn_primary w_fit_content'
                                    style={{ cursor: "default" }}
                                >
                                    <span>Save</span>
                                    <img src={loaderIcon} alt='USP' className='loader_icon' />
                                </button>
                            ) : (
                                <button className='w_120_d2 btn btn_primary w_fit_content'
                                    onClick={handleSubmit}
                                >
                                    <span>Save</span>
                                    <img src={loaderIcon} alt='USP' className='loader_icon' />
                                </button>
                            )}
                        </div>
                    </>

                </>
            </div>
        </div >
    )
}

export default OnboardingStep1
